"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _Menu = require("../Menu/Menu.stories");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sider = _antd.Layout.Sider;
var Wrapper = (0, _styledComponents.default)(_antd.Layout)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-height: 100vh;\n"])));
var SiderBar = (0, _styledComponents.default)(Sider)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  min-height: 100%;\n  .ant-menu {\n    background: transparent;\n    border-right: 0;\n    margin-top: 8px;\n  }\n  .ant-menu-item {\n    font-size: ", ";\n    color: ", ";\n    height: 48px;\n    line-height: 48px;\n    padding: 0 16px;\n    &.ant-menu-item-selected {\n      &::after {\n        border-right: 3px solid ", ";\n      }\n    }\n    &:after {\n      border-right: 3px solid ", ";\n    }\n    &:hover {\n      .menu-item {\n        background-color: ", ";\n      }\n    }\n  }\n  .ant-menu-item-group-title {\n    font-size: ", ";\n    padding: 8px 16px;\n  }\n  .menu-item {\n    color: ", ";\n    padding: 0;\n  }\n"])), _theme.theme.colors.white, _theme.theme.font_size.size_l, _theme.theme.colors.grey_tertiary, _theme.theme.colors.royal_blue, _theme.theme.colors.royal_blue, _theme.theme.colors.transparent, _theme.theme.font_size.size_m, _theme.theme.colors.grey_tertiary);

var Logo = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  min-width: 100%;\n  width: 100%;\n"])));

function Sidebar(props) {
  var width = props.width,
      sidebarLogo = props.sidebarLogo;

  var defaultObject = _objectSpread(_objectSpread({}, _Menu.MenuWithItemGroup.args), {}, {
    width: "100%"
  });

  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(SiderBar, {
    width: width
  }, /*#__PURE__*/_react.default.createElement(Logo, {
    src: sidebarLogo
  }), /*#__PURE__*/_react.default.createElement(_Menu.MenuWithItemGroup, defaultObject)));
}

var _default = Sidebar;
exports.default = _default;